export default __webpack_public_path__ + "static/media/google.284ac6c6.png";